<template>
  <div class="DateSelectorContainer">

    <nut-row className="dateContainer" :gutter="12">
      <nut-col :span="12" class="bothCenter" v-for="(d,di) in plans" :key="`date_${d.id}`">
        <DateSelectorItem :data="d" :selected="selectedPid == di" @click="selectDate(di)"/>
      </nut-col>
    </nut-row>
    <nut-row className="dateContainer" style="justify-content: center;" :gutter="12" v-if="plans.length>0">
      <nut-col :span="24" class="bothCenter" v-if="selectedPid<0">
        <nut-button class="btn1" @click="bookVisit">报名预约</nut-button>
      </nut-col>
      <template v-else>
        <nut-col :span="8" class="bothCenter" v-if="selectedPlan.supportBookTypes&&selectedPlan.supportBookTypes.includes('PING')">
          <nut-button class="btn1" @click="createPin">创建拼团</nut-button>
        </nut-col>
        <nut-col :span="8" class="bothCenter" v-if="selectedPlan.supportBookTypes&&selectedPlan.supportBookTypes.includes('GROUP')">
          <nut-button class="btn2" @click="createGroupVisit">团队预约</nut-button>
        </nut-col>
        <nut-col :span="8" class="bothCenter" v-if="selectedPlan.supportBookTypes&&selectedPlan.supportBookTypes.includes('FAMILY')">
          <nut-button class="btn3" @click="createFamilyVisit">家庭预约</nut-button>
        </nut-col>
      </template>

    </nut-row>
  </div>
</template>

<script>
import DateSelectorItem from "@/components/date/DateSelectorItem";
import {Toast} from "@nutui/nutui";

export default {
  name: "DateSelector",
  components: {DateSelectorItem},
  props: {
    stationId: {
      type: Number,
      default: 0
    },
    plans:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      selectedPid: -1,
      selectedPlan: {}
    }
  },
  methods: {
    bookVisit(){
      if(this.selectedPid < 0 ){
        Toast.fail('请先选择时段')
        return
      }
    },
    createFamilyVisit() {
      if (this.selectedPid < 0 || this.selectedPid >= this.plans.length) {
        Toast.fail('请先选择时段')
        return
      }
      this.$router.push(`/date/family/create/${this.stationId}/${this.plans[this.selectedPid].id}`)
    },
    createGroupVisit() {
      if (this.selectedPid < 0 || this.selectedPid >= this.plans.length) {
        Toast.fail('请先选择时段')
        return
      }
      this.$router.push(`/date/visit/group/create/${this.stationId}/${this.plans[this.selectedPid].id}`)
    },
    createPin() {
      if (this.selectedPid < 0 || this.selectedPid >= this.plans.length) {
        Toast.fail('请先选择时段')
        return
      }
      this.$router.push(`/date/pin/create/${this.stationId}/${this.plans[this.selectedPid].id}`)
    },
    selectDate(pid) {
      if (this.plans[pid].visit) {
        Toast.fail('该时段无法接待')
        return
      }
      if (this.plans[pid].timeLock) {
        Toast.fail('该时段无法预约，请在一个月内预约')
        return
      }
      this.selectedPid = pid;
      this.selectedPlan = this.plans[pid];
    },
    init() {
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.DateSelectorContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding-bottom: 8px;
  border-radius: 0 0 24px 24px;

  .btn1 {
    width: 100%;
    height: 44px;
    color: #2F438C;
    background-color: rgba(0, 100, 255, 0.1);
    border-radius: 12px;
    border: none;
  }

  .btn2 {
    width: 100%;
    height: 44px;
    color: white;
    background: #2F438C;
    border-radius: 12px;
    border: none;
  }
  .btn3 {
    width: 100%;
    height: 44px;
    color: #2F438C;
    background-color: rgba(0, 100, 255, 0.2);
    border-radius: 12px;
    border: none;
  }
  .checked {
    width: 23px;
    height: 23px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .dateContainer {
    padding: 8px 16px;
    display: flex;
  }


}
</style>